<template>
  <div>
    <p class="mb-3">
      Which of the structures shown below is the correct Lewis dot structure for
      <stemble-latex content="$\ce{ClO?}$" />
    </p>

    <p class="mb-0 pl-3">
      <img :src="$publicAsset('/img/assignments/ClO_LS.png')" width="85%" />
    </p>

    <v-form @submit.prevent="submitResponse">
      <v-radio-group v-model="inputs.input1" :disabled="!allowEditing">
        <v-radio
          v-for="option in options"
          :key="option.value"
          class="d-inline-block"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'Question336',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking

      inputs: {
        input1: null,
      },
      options: [
        {text: '$\\text{Structure A}$', value: 'a'},
        {text: '$\\text{Structure B}$', value: 'b'},
        {text: '$\\text{Structure C}$', value: 'c'},
        {text: '$\\text{Structure D}$', value: 'd'},
        {text: '$\\text{Structure E}$', value: 'e'},
      ],
    };
  },
};
</script>
